var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.036,
    height: 15.036,
    viewBox: "0 0 15.036 15.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_27_layout",
    "data-name": "27 layout",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29591",
    "data-name": "Path 29591",
    d: "M8.444,2H2.537A.537.537,0,0,0,2,2.537V8.444a.537.537,0,0,0,.537.537H8.444a.537.537,0,0,0,.537-.537V2.537A.537.537,0,0,0,8.444,2ZM7.907,7.907H3.074V3.074H7.907ZM16.5,10.055H10.592a.537.537,0,0,0-.537.537V16.5a.537.537,0,0,0,.537.537H16.5a.537.537,0,0,0,.537-.537V10.592A.537.537,0,0,0,16.5,10.055Zm-.537,5.907H11.129V11.129h4.833Zm-6.981-4.3a.537.537,0,0,1-.537.537H2.537a.537.537,0,0,1,0-1.074H8.444A.537.537,0,0,1,8.981,11.666Zm0,3.759a.537.537,0,0,1-.537.537H2.537a.537.537,0,0,1,0-1.074H8.444A.537.537,0,0,1,8.981,15.425ZM10.055,3.611a.537.537,0,0,1,.537-.537H16.5a.537.537,0,0,1,0,1.074H10.592A.537.537,0,0,1,10.055,3.611ZM17.036,7.37a.537.537,0,0,1-.537.537H10.592a.537.537,0,0,1,0-1.074H16.5A.537.537,0,0,1,17.036,7.37Z",
    transform: "translate(-2 -2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplates);
export default __webpack_public_path__ + "static/media/templates.e62ed2e40109030c9ae917dfaa207b93.svg";
export { ForwardRef as ReactComponent };